import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { CanComponentDeactivate } from 'app/core/guards';
import { CountryService, GlobalFunctionsService, PostalCodeService } from 'app/core/services';
import { Country, Course, Order } from 'app/shared/models';
import { environment } from 'environments/environment';

@Component({
  moduleId: module.id,
  selector: 'fo-payment',
  templateUrl: './payment.page.html'
})
export class PaymentPage implements OnInit, CanComponentDeactivate {
  order: Order;
  countries: Country[];
  course: Course;
  formDeactivationCheck = false;
  selectedIssuer: string;
  paymentType = 'invoice';
  enableTerms = false;

  issuers = [
    { name: 'ABN AMRO', bic: 'ABNANL2A' },
    { name: 'ASN Bank', bic: 'ASNBNL21' },
    { name: 'ING', bic: 'INGBNL2A' },
    { name: 'Rabobank', bic: 'RABONL2U' },
    { name: 'SNS Bank', bic: 'SNSBNL2A' },
    { name: 'SNS Regio Bank', bic: 'RBRBNL21' },
    { name: 'Triodos Bank', bic: 'TRIONL2U' },
    { name: 'Van Lanschot', bic: 'FVLBNL22' },
    { name: 'Knab', bic: 'KNABNL2H' },
    { name: 'Bunq', bic: 'BUNQNL2A' },
    { name: 'Moneyou', bic: 'MOYONL21' },
    { name: 'Handelsbanken', bic: 'HANDNL2A' }
  ];

  @ViewChild('contactForm', { static: false }) form: NgForm;

  constructor(
    protected countryService: CountryService,
    protected globalFunctionsService: GlobalFunctionsService,
    protected postalCodeService: PostalCodeService,
    protected router: Router,
    protected config: AppConfig
  ) {
    this.globalFunctionsService.showBasket(true);
    this.globalFunctionsService.showTabs(true);
    this.selectedIssuer = this.globalFunctionsService.selectedIssuer || '';
  }

  updateIssuer(): void {
    this.globalFunctionsService.selectedIssuer = this.selectedIssuer;
  }

  getCountries(): void {
    this.countryService.getCountries().then(countries => (this.countries = countries));
  }

  saveInfo(isValid: boolean): void {
    if (isValid) {
      // Show Summary
      this.globalFunctionsService.enableTabs(4);
      // Redirect
      // TODO: Animate
      window.scrollTo(0, 0);
      this.router.navigate(['confirm'], { queryParamsHandling: 'merge' });
    }
  }

  previousTab(): void {
    // Redirect
    // TODO: Animate
    window.scrollTo(0, 0);
    this.router.navigate(['students'], { queryParamsHandling: 'merge' });
  }

  ngOnInit(): void {
    this.paymentType = environment.paymentType;
    this.getCountries();
    this.order = this.globalFunctionsService.getOrder();
    this.course = this.globalFunctionsService.getSelectedCourse();

    if (((this.order.Students ? this.order.Students.length : 0) + (this.order.FirstStudentIsContact ? 1 : 0)) * this.course.Price >= 800) {
      this.enableTerms = true;
    } else {
      this.order.PaymentTerms = '1';
    }
  }

  getAddress(): void {
    this.postalCodeService
      .getAddress(this.order.InvoicePerson.PostalCode, this.order.InvoicePerson.AddressNumber)
      .then(address => {
        this.order.InvoicePerson.Address = address.Street;
        this.order.InvoicePerson.City = address.City;
      })
      .catch(() => {
        // Ignore errors.
      });
  }

  createFullName(gender: string, initials: string, middleName: string, surname: string, includeTav: boolean): string {
    let fullName = includeTav ? 'T.a.v. ' : '';

    if (gender) {
      if (gender === 'M') {
        fullName += includeTav ? 'de heer ' : 'De heer ';
      } else {
        fullName += includeTav ? 'mevrouw ' : 'Mevrouw ';
      }
    }

    if (initials) {
      fullName += initials + ' ';
    }

    if (middleName) {
      fullName += middleName + ' ';
    }

    if (surname) {
      fullName += surname;
    }

    return fullName;
  }

  canDeactivate(): boolean {
    this.formDeactivationCheck = true;
    return this.form.valid;
  }
}
